export const STATES_LIST_WITH_CODE = [
  {
    value: "Jammu & Kashmir",
    label: "01-Jammu & Kashmir",
  },
  {
    value: "Himachal Pradesh",
    label: "02-Himachal Pradesh",
  },
  {
    value: "Punjab",
    label: "03-Punjab",
  },
  {
    value: "Chandigarh",
    label: "04-Chandigarh",
  },
  {
    value: "Uttarakhand",
    label: "05-Uttarakhand",
  },
  {
    value: "Haryana",
    label: "06-Haryana",
  },
  {
    value: "Delhi",
    label: "07-Delhi",
  },
  {
    value: "Rajasthan",
    label: "08-Rajasthan",
  },
  {
    value: "Uttar Pradesh",
    label: "09-Uttar Pradesh",
  },
  {
    value: "Bihar",
    label: "10-Bihar",
  },
  {
    value: "Sikkim",
    label: "11-Sikkim",
  },
  {
    value: "Arunachal Pradesh",
    label: "12-Arunachal Pradesh",
  },
  {
    value: "Nagaland",
    label: "13-Nagaland",
  },
  {
    value: "Manipur",
    label: "14-Manipur",
  },
  {
    value: "Mizoram",
    label: "15-Mizoram",
  },
  {
    value: "Tripura",
    label: "16-Tripura",
  },
  {
    value: "Meghalaya",
    label: "17-Meghalaya",
  },
  {
    value: "Assam",
    label: "18-Assam",
  },
  {
    value: "West Bengal",
    label: "19-West Bengal",
  },
  {
    value: "Jharkhand",
    label: "20-Jharkhand",
  },
  {
    value: "Odisha",
    label: "21-Odisha",
  },
  {
    value: "Chhattisgarh",
    label: "22-Chhattisgarh",
  },
  {
    value: "Madhya Pradesh",
    label: "23-Madhya Pradesh",
  },
  {
    value: "Gujarat",
    label: "24-Gujarat",
  },
  {
    value: "Daman & Diu",
    label: "25-Daman & Diu",
  },
  {
    value: "Dadra & Nagar Haveli & Daman & Diu",
    label: "26-Dadra & Nagar Haveli & Daman & Diu",
  },
  {
    value: "Maharashtra",
    label: "27-Maharashtra",
  },
  {
    value: "Karnataka",
    label: "29-Karnataka",
  },
  {
    value: "Goa",
    label: "30-Goa",
  },
  {
    value: "Lakshdweep",
    label: "31-Lakshdweep",
  },
  {
    value: "Kerala",
    label: "32-Kerala",
  },
  {
    value: "Tamil Nadu",
    label: "33-Tamil Nadu",
  },
  {
    value: "Puducherry",
    label: "34-Puducherry",
  },
  {
    value: "Andaman & Nicobar Islands",
    label: "35-Andaman & Nicobar Islands",
  },
  {
    value: "Telangana",
    label: "36-Telangana",
  },
  {
    value: "Andhra Pradesh",
    label: "37-Andhra Pradesh",
  },
  {
    value: "Ladakh",
    label: "38-Ladakh",
  },
  {
    value: "Other Territory",
    label: "97-Other Territory",
  },
];

export const STATES_LIST = [
  {
    value: "Jammu & Kashmir",
    label: "Jammu & Kashmir",
  },
  {
    value: "Himachal Pradesh",
    label: "Himachal Pradesh",
  },
  {
    value: "Punjab",
    label: "Punjab",
  },
  {
    value: "Chandigarh",
    label: "Chandigarh",
  },
  {
    value: "Uttarakhand",
    label: "Uttarakhand",
  },
  {
    value: "Haryana",
    label: "Haryana",
  },
  {
    value: "Delhi",
    label: "Delhi",
  },
  {
    value: "Rajasthan",
    label: "Rajasthan",
  },
  {
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
  },
  {
    value: "Bihar",
    label: "Bihar",
  },
  {
    value: "Sikkim",
    label: "Sikkim",
  },
  {
    value: "Arunachal Pradesh",
    label: "Arunachal Pradesh",
  },
  {
    value: "Nagaland",
    label: "Nagaland",
  },
  {
    value: "Manipur",
    label: "Manipur",
  },
  {
    value: "Mizoram",
    label: "Mizoram",
  },
  {
    value: "Tripura",
    label: "Tripura",
  },
  {
    value: "Meghalaya",
    label: "Meghalaya",
  },
  {
    value: "Assam",
    label: "Assam",
  },
  {
    value: "West Bengal",
    label: "West Bengal",
  },
  {
    value: "Jharkhand",
    label: "Jharkhand",
  },
  {
    value: "Odisha",
    label: "Odisha",
  },
  {
    value: "Chhattisgarh",
    label: "Chhattisgarh",
  },
  {
    value: "Madhya Pradesh",
    label: "Madhya Pradesh",
  },
  {
    value: "Gujarat",
    label: "Gujarat",
  },
  {
    value: "Daman & Diu",
    label: "Daman & Diu",
  },
  {
    value: "Dadra & Nagar Haveli & Daman & Diu",
    label: "Dadra & Nagar Haveli & Daman & Diu",
  },
  {
    value: "Maharashtra",
    label: "Maharashtra",
  },
  {
    value: "Karnataka",
    label: "Karnataka",
  },
  {
    value: "Goa",
    label: "Goa",
  },
  {
    value: "Lakshdweep",
    label: "Lakshdweep",
  },
  {
    value: "Kerala",
    label: "Kerala",
  },
  {
    value: "Tamil Nadu",
    label: "Tamil Nadu",
  },
  {
    value: "Puducherry",
    label: "Puducherry",
  },
  {
    value: "Andaman & Nicobar Islands",
    label: "Andaman & Nicobar Islands",
  },
  {
    value: "Telangana",
    label: "Telangana",
  },
  {
    value: "Andhra Pradesh",
    label: "Andhra Pradesh",
  },
  {
    value: "Ladakh",
    label: "Ladakh",
  },
  {
    value: "Other Territory",
    label: "Other Territory",
  },
];

export const EXPENSESTYPE = [
  {
    value: "tax_invoice",
    label: "Tax Invoice",
  },
  {
    value: "debit_note",
    label: "Debit Note",
  },
  {
    value: "credit_note",
    label: "Credit Note",
  },
  {
    value: "purchase_order",
    label: "Purchase Order",
  },
  {
    value: "rcm_invoice",
    label: "Tax Invoice (RCM applicable)",
  },
];

export const REVENUESTYPE = [
  {
    value: "tax_invoice",
    label: "Tax Invoice",
  },
  {
    value: "debit_note",
    label: "Debit Note",
  },
  {
    value: "credit_note",
    label: "Credit Note",
  },
  {
    value: "estimation",
    label: "Estimation",
  },
  // commented for future use
  // {
  //   value: "proforma_invoice",
  //   label: "Proforma Invoice"
  // }
  // ,
  // {
  //   value: "recepits",
  //   label: "Receipts",
  // },
];
